<app-loader id="header-loader" />
<header
  class="h-fit bg-white border-b border-slate-200 flex items-center justify-between p-4 sticky top-0 z-10"
>
  <div class="flex gap-3 items-center">
    <button
      type="button"
      (click)="onToggleSidebar()"
      [pTooltip]="sidebarService.isCollapsed() ? 'Expand sidebar' : 'Collapse sidebar'"
      tooltipPosition="bottom"
      class="flex items-center justify-center w-9 h-9 rounded-xl border border-slate-200 hover:border-slate-300 hover:bg-slate-100/80 text-slate-600 hover:text-slate-900 transition-all cursor-pointer shadow-2xs"
      aria-label="Toggle Sidebar"
    >
      <!-- Modern Sidebar Layout & Directional Toggle Icon -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="w-4.5 h-4.5"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <rect width="18" height="18" x="3" y="3" rx="2.5" ry="2.5" class="stroke-slate-500"></rect>
        <path d="M9 3v18" class="stroke-slate-500" stroke-width="2.2"></path>
        <path
          [attr.d]="sidebarService.isCollapsed() ? 'M13.5 9.5l2.5 2.5-2.5 2.5' : 'M16 9.5l-2.5 2.5 2.5 2.5'"
          class="stroke-primary"
          stroke-width="2"
        ></path>
      </svg>
    </button>
    <div class="flex gap-2 items-center">
      @if (headerService.title()) {
      <h1 class="text-xl font-semibold text-slate-800">{{ headerService.title() }}</h1>
      } @if(headerService.subTitle()) { -
      <span class="text-slate-700 text-xl">{{ headerService.subTitle() }}</span>
      }
    </div>
  </div>

  <div class="flex items-center justify-center">
    <div
      class="group flex items-center gap-4 border-none bg-transparent outline-none cursor-pointer p-0"
    >
      <button type="button" (click)="menu.toggle($event)" class="cursor-pointer focus:outline-none">
        <div
          class="flex items-center gap-2.5 border border-slate-200 hover:border-slate-300 hover:bg-slate-50/70 p-1.5 pr-3.5 rounded-full transition-all shadow-2xs"
        >
          <div class="relative flex">
            <p-avatar
              icon="pi pi-user"
              shape="circle"
              class="w-9 h-9 bg-slate-100 text-slate-500 border border-slate-200 shadow-xs"
            />
            <span
              class="absolute bottom-0 right-0 block w-2.5 h-2.5 bg-emerald-500 border-2 border-white rounded-full"
            ></span>
          </div>

          <div class="flex flex-col text-left">
            <span class="text-xs font-semibold text-slate-900 leading-tight flex items-center gap-1.5">
              <i class="pi pi-building text-primary text-[11px]"></i>
              <span>{{ tenantName }}</span>
              <span
                class="px-1.5 py-0.2 text-[9px] font-medium rounded-full border leading-tight"
                [ngClass]="
                  tenantService.isPoolIndustryTenant()
                    ? 'bg-teal-50 text-teal-700 border-teal-200'
                    : 'bg-pink-50 text-primary border-pink-200'
                "
              >
                {{ tenantService.isPoolIndustryTenant() ? 'Pool' : 'Medical' }}
              </span>
            </span>
            @if (userName) {
              <span class="text-[11px] text-slate-500 leading-tight truncate max-w-[150px]">{{ userName }}</span>
            }
          </div>

          <i class="pi pi-chevron-down text-slate-400 text-xs ml-0.5"></i>
        </div>
      </button>
    </div>
  </div>
</header>

<p-menu
  #menu
  [model]="userMenuItems"
  [popup]="true"
  [style]="{ 'transform-origin': 'right' }"
  styleClass="m-2 min-w-48 shadow-2xl border border-slate-100 menu-right"
/>
